(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia('(min-width: 45em)');

  /* sticky header after 100px, like the original */
  function onScrollClass(){ document.body.classList.toggle('ub-scrolled', window.scrollY > 100); }
  onScrollClass();

  /* marquee at a steady 30px per second */
  document.querySelectorAll('[data-ub-marquee] .ub-bar__track').forEach(function(track){
    function setup(){
      var half = track.scrollWidth / 2;
      track.style.setProperty('--shift', (-half) + 'px');
      track.style.setProperty('--dur', (half / 30) + 's');
    }
    setup();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(setup);
  });

  /* scroll accordions: an item opens when its (invisible, fully expanded) twin reaches the middle of the screen */
  var accs = [].slice.call(document.querySelectorAll('[data-ub-acc]')).map(function(acc){
    var live = [].slice.call(acc.querySelectorAll('.ub-acc__live > *'));
    var ghost = [].slice.call(acc.querySelectorAll('.ub-acc__ghost > *'));
    acc.classList.add('is-ready');
    live.forEach(function(item, i){
      var title = item.querySelector('.ub-acc__title');
      if (title && ghost[i]) title.addEventListener('click', function(){
        if (!desktop.matches) return;
        var top = ghost[i].getBoundingClientRect().top + window.scrollY - window.innerHeight / 2 + 100;
        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    return { live: live, ghost: ghost };
  });
  function updateAccs(){
    var mid = window.innerHeight / 2;
    accs.forEach(function(a){
      a.live.forEach(function(item, i){
        var g = a.ghost[i];
        if (!g) return;
        item.classList.toggle('is-on', g.getBoundingClientRect().top <= mid);
      });
    });
  }

  /* packshot drifts from +100px to -100px while the section scrolls by, with a little lag */
  var packs = [].slice.call(document.querySelectorAll('.ub-pack')).map(function(sec){
    return { sec: sec, img: sec.querySelector('.ub-pack__img'), cur: null };
  }).filter(function(p){ return p.img; });
  var animating = false;
  function targetY(p){
    var r = p.sec.getBoundingClientRect(), vh = window.innerHeight;
    var prog = (vh - r.top) / (vh + r.height);
    prog = Math.max(0, Math.min(1, prog));
    return 100 - 200 * prog;
  }
  function stepPacks(){
    var again = false;
    packs.forEach(function(p){
      var t = targetY(p);
      if (p.cur === null) p.cur = t;
      p.cur += (t - p.cur) * 0.18;
      if (Math.abs(t - p.cur) > 0.2) again = true; else p.cur = t;
      p.img.style.transform = 'translateY(' + p.cur.toFixed(2) + 'px)';
    });
    if (again) requestAnimationFrame(stepPacks); else animating = false;
  }
  function kickPacks(){
    if (reduce || !packs.length || animating) return;
    animating = true;
    requestAnimationFrame(stepPacks);
  }

  var ticking = false;
  function onScroll(){
    onScrollClass();
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function(){ updateAccs(); ticking = false; });
    kickPacks();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  updateAccs();
  kickPacks();

  /* faq: smooth open and close (with a timer fallback so it never gets stuck) */
  document.querySelectorAll('.ub-faq__item').forEach(function(d){
    var sum = d.querySelector('summary'), panel = d.querySelector('.ub-faq__a');
    if (!sum || !panel || !panel.animate) return;
    sum.addEventListener('click', function(e){
      e.preventDefault();
      if (d._anim){ d._anim.cancel(); d._anim = null; }
      var opening = !d.open, dur = reduce ? 0 : 300;
      var h;
      if (opening){ d.open = true; d.style.removeProperty('--open'); h = panel.scrollHeight; }
      else { h = panel.scrollHeight; d.style.setProperty('--open', '0'); }
      var done = function(){
        if (d._t){ clearTimeout(d._t); d._t = null; }
        if (d._anim){ d._anim.cancel(); d._anim = null; }
        if (!opening){ d.open = false; d.style.removeProperty('--open'); }
      };
      d._anim = panel.animate(opening ? [{ height: '0px' }, { height: h + 'px' }] : [{ height: h + 'px' }, { height: '0px' }], { duration: dur, easing: 'ease-in-out' });
      d._anim.onfinish = done;
      d._t = setTimeout(done, dur + 150);
    });
  });

  /* quick buy: one click from a package straight to checkout */
  document.querySelectorAll('form[data-ub-quickbuy]').forEach(function(form){
    form.addEventListener('submit', function(e){
      if (!window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('button');
      var id = form.querySelector('input[name="id"]').value;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      if (btn){ btn.disabled = true; btn.innerHTML = btn.dataset.loading || '…'; }
      fetch(root + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function(){
          return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) });
        })
        .then(function(r){ if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function(){
          if (window.fbq){ try { fbq('track', 'InitiateCheckout'); } catch (err) {} }
          window.location.href = root + 'checkout';
        })
        .catch(function(){ form.submit(); });
    });
  });

  /* sticky mobile buy button, hidden over the hero and the package section */
  var sticky = document.querySelector('.ub-sticky');
  var shop = document.getElementById('shop');
  var hero = document.querySelector('.ub-hero');
  if (sticky && shop && 'IntersectionObserver' in window){
    var shopVisible = false, heroVisible = true;
    var update = function(){ sticky.classList.toggle('is-visible', !shopVisible && !heroVisible); };
    new IntersectionObserver(function(en){ shopVisible = en[0].isIntersecting; update(); }, { threshold: 0.05 }).observe(shop);
    if (hero) new IntersectionObserver(function(en){ heroVisible = en[0].isIntersecting; update(); }, { threshold: 0.1 }).observe(hero);
    else { heroVisible = false; update(); }
  }
})();
